import { useCallback, useContext, useEffect, useState } from 'react'
import { AlertContext } from '../contexts/AlertContext';
import { SocketContext } from '../contexts/SocketContext';
import { LoaderContext } from '../contexts/LoaderContext';

export const useSettings = (loading = true) => {

    const [settings, setSettings] = useState({});

    const { alertRef } = useContext(AlertContext);
    const { socket } = useContext(SocketContext);
    const { setOpenLoader } = useContext(LoaderContext);

    useEffect(() => {
        let subscribed = true;
        
        if(subscribed) 
            loading && setOpenLoader(true);
            getSettings();

        return () => subscribed = false;
    }, []);

    const getSettings = useCallback(() => {
        socket.emit('frontend:obtener-configuracion', (response) => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setSettings(data);
            setOpenLoader(false);
        });
    }, []);

    const updateSettings = (args) => {
        setOpenLoader(true);
        const { _id, msj_tratamiento_datos_encuestas, msj_despedida_encuestas, meta_satisfaccion, meta_recomendacion, peso_satisfaccion, correo } = args;

        console.log(peso_satisfaccion);
        
        socket.emit('frontend:actualizar-configuracion', {
            _id,
            msj_tratamiento_datos_encuestas: msj_tratamiento_datos_encuestas?.trim(),
            msj_despedida_encuestas: msj_despedida_encuestas?.trim(),
            meta_satisfaccion: meta_satisfaccion?.trim(),
            meta_recomendacion: meta_recomendacion?.trim(),
            peso_satisfaccion: peso_satisfaccion?.split(',')?.map(p => p?.trim()),
            correo: correo?.trim()
        }, response => {

            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current?.handleOpen('error', message);
                return;
            }
            
            setSettings(data);
            setOpenLoader(false);
        });
    }

    return {
        settings,
        updateSettings
    }
}